// extracted by mini-css-extract-plugin
export var gridViewWrapper = "PeopleGridView-module--grid-view-wrapper--1JeHA";